import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { s as state } from './index3.js';
import { d as defineCustomElement$1 } from './button-base2.js';

import { baseCss } from './css.js';
const nlSigninReadOnlyCss = baseCss;

const NlSigninReadOnlyStyle0 = nlSigninReadOnlyCss;

const NlSigninReadOnly = /*@__PURE__*/ proxyCustomElement(class NlSigninReadOnly extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.nlLoginReadOnly = createEvent(this, "nlLoginReadOnly", 7);
        this.nlCheckLogin = createEvent(this, "nlCheckLogin", 7);
        this.titleLogin = 'Log in to read only';
        this.description = 'Please enter the user name or npub of any Nostr user.';
        this.isGood = false;
    }
    handleInputChange(event) {
        state.nlSigninReadOnly.loginName = event.target.value;
        this.nlCheckLogin.emit(event.target.value); // .emit(this.loginName);
    }
    handleLogin(e) {
        e.preventDefault();
        this.nlLoginReadOnly.emit(state.nlSigninReadOnly.loginName);
    }
    render() {
        return (h(Fragment, { key: '5333cc7e682b148d2b2c9d3756c9fa561a9a3e86' }, h("div", { key: 'ed025d719382b9b4ac11a24d3814419a6f51c774', class: "p-4 overflow-y-auto" }, h("h1", { key: '8b8c0c1e839b3db4529e1c6acc8ef18e29a7abee', class: "nl-title font-bold text-center text-2xl" }, this.titleLogin), h("p", { key: '36f9334b55aea6c5e46bc6e143388b757a6be867', class: "nl-description font-light text-center text-sm pt-2 max-w-96 mx-auto" }, this.description)), h("div", { key: '3197bd6ac9835cdb4a9b64ff0dea262ddb92ef13', class: "max-w-72 mx-auto" }, h("div", { key: 'f804f5111ac8f9aaa17b404c22d58ea875273382', class: "relative mb-2" }, h("input", { key: '7828eb7e49e92a0578a73439ae16de63caa57597', onInput: e => this.handleInputChange(e), type: "text", class: "nl-input peer py-3 px-4 ps-11 block w-full border-transparent rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none dark:border-transparent", placeholder: "npub or name@domain", value: state.nlSigninReadOnly.loginName }), h("div", { key: '1557e4f05bac2eefc05e22806cb0024e5430c7f4', class: "absolute inset-y-0 start-0 flex items-center pointer-events-none ps-4 peer-disabled:opacity-50 peer-disabled:pointer-events-none" }, h("svg", { key: 'dfd2f9eeb07d815807bdb4885680001d3d5a1a2c', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: this.isGood ? '#00cc00' : 'currentColor', class: "flex-shrink-0 w-4 h-4 text-gray-500" }, h("path", { key: 'beb199e08cbb0d385314e4a3fcb521bbc05e7d2d', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" }), h("path", { key: '988fe07d787ff2fbb15c620681b2996fcd0ff382', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" })))), h("div", { key: '652f082e184f5d871629f8054a2474c80adddf4b', class: "ps-4 pe-4 overflow-y-auto" }, h("p", { key: '5583f0eb95400902d72728989f32c3afaf31fc77', class: "nl-error font-light text-center text-sm max-w-96 mx-auto" }, state.error)), h("button-base", { key: 'e708d09f4e1625af23d8f432c8523662ad1c82dd', titleBtn: "Log in", disabled: state.isLoading, onClick: e => this.handleLogin(e) }, state.isLoading && (h("span", { key: '5422a05cd6a2b0309fd78f95bf89b0ff03ab69e9', slot: "icon-start", class: "animate-spin-loading inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full", role: "status", "aria-label": "loading" }))))));
    }
    static get style() { return NlSigninReadOnlyStyle0; }
}, [0, "nl-signin-read-only", {
        "titleLogin": [1, "title-login"],
        "description": [1],
        "isGood": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-signin-read-only", "button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-signin-read-only":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlSigninReadOnly);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlSigninReadOnly as N, defineCustomElement as d };

//# sourceMappingURL=nl-signin-read-only2.js.map